export const MQ_TZ = "America/Martinique";

export const CAT_META = {
  a_planifier: { label: "À planifier", short: "À planifier", pill: "bg-orange-50 text-orange-700 border-orange-200", dot: "bg-orange-500", icon: "CalendarPlus", tile: "bg-orange-50 text-orange-500", chip: "border-l-orange-400 bg-orange-50/70" },
  planifie: { label: "Planifiés", short: "Planifié", pill: "bg-blue-50 text-blue-700 border-blue-200", dot: "bg-blue-500", icon: "CalendarCheck", tile: "bg-blue-50 text-blue-600", chip: "border-l-blue-500 bg-blue-50/70" },
  en_cours: { label: "En cours", short: "En cours", pill: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500", icon: "Play", tile: "bg-emerald-50 text-emerald-600", chip: "border-l-emerald-500 bg-emerald-50/70" },
  en_pause: { label: "En pause", short: "En pause", pill: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500", icon: "Pause", tile: "bg-amber-50 text-amber-600", chip: "border-l-amber-400 bg-amber-50/70" },
  termine: { label: "Terminés", short: "Terminé", pill: "bg-slate-100 text-slate-600 border-slate-200", dot: "bg-slate-400", icon: "Flag", tile: "bg-slate-100 text-slate-500", chip: "border-l-slate-300 bg-slate-50" },
};

export function mqToday() {
  return new Intl.DateTimeFormat("en-CA", { timeZone: MQ_TZ }).format(new Date());
}

export function fmtShortDate(d) {
  if (!d) return "";
  const [y, m, day] = d.split("-").map(Number);
  return new Date(y, m - 1, day).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" });
}

export function fmtHour(t) {
  if (!t) return "";
  const [h, mi] = t.split(":");
  return `${Number(h)} h${mi !== "00" ? ` ${mi}` : ""}`;
}

export function fmtStart(w) {
  if (!w.planned_start || (w.category === "a_planifier")) return null;
  const when = w.all_day ? "Journée entière" : w.start_time ? fmtHour(w.start_time) : "";
  return `${fmtShortDate(w.planned_start)}${when ? ` · ${when}` : ""}`;
}

export function fmtEnd(w) {
  if (!w.planned_end || w.category === "a_planifier") return null;
  if (w.planned_end === w.planned_start && !w.end_time) return null;
  return `${fmtShortDate(w.planned_end)}${w.end_time ? ` · ${fmtHour(w.end_time)}` : ""}`;
}
